export default __webpack_public_path__ + "static/media/multimedia.691fed9f.svg";